import { ErrorHandler, Injectable, Injector, inject } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { VersionService } from './version.service';

@Injectable()
export class AppErrorHandler implements ErrorHandler {
  private injector = inject(Injector);

  private readonly sentryErrorHandler = Sentry.createErrorHandler({
    showDialog: false,
  });

  handleError(error: unknown): void {
    // Resolved lazily: VersionService depends on the router and the modal
    // stack, neither of which exists yet when the ErrorHandler is created.
    this.injector.get(VersionService).handleStaleChunkError(error);
    this.sentryErrorHandler.handleError(error);
  }
}
